<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :isRequiredFarms="true"
              :filterOfLots="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-md-6 col-xl-4"
              ref="filters"
            >
              <!-- classLots="col-12 col-md-6 col-xl-4" -->
              <template slot="prev">
                <div :class="`col-12 col-sm-12 col-md-6 col-xl-3 pt-3`">
                  <label for="">{{ $t('common_words.device_type') }}: * </label>
                  <br />
                  <el-select
                    @change="handleChangeDeviceType()"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    class="select-primary custom-width-select shadow-sm required-device_type"
                    v-model="device_type"
                    :placeholder="`${$t('common_words.select')}...`"
                    :disabled="getPermision"
                  >
                    <el-option
                      class="select-primary"
                      v-for="item in getDeviceType"
                      :key="item.id + item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>

              <div></div>
              <template slot="after-lot">
                <div :class="`col-12 col-md-6 col-xl-5 mt-3`">
                  <label for="">{{ $t('common_words.activities') }}:</label>
                  <br />
                  <el-select
                    @change="
                      selectAllFromSelect('dataFilter.activities', activities)
                    "
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    multiple
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.activities"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in activities"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="device_type != 'mobile'" :class="`col-12 pt-3`">
                  <label for="">{{ $t('labor.workers') }}:</label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('dataFilter.workers', workers)"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    multiple
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.workers"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in workers"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div v-if="device_type == 'mobile'" :class="`col-12 pt-3`">
                  <label for="">{{ $t('common_words.user') }}:</label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('dataFilter.users', users)"
                    clearable
                    collapse-tags
                    style="width: 100%"
                    filterable
                    multiple
                    class="select-primary custom-width-select shadow-sm"
                    v-model="dataFilter.users"
                    :placeholder="`${$t('common_words.select')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in users"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <div v-if="isIndex()">
        <div v-if="device_type != 'mobile'">
          <card v-if="tableData.length > 0">
            <!-- main table -->
            <br />
            <div>
              <card-header
                :propPagination="pagination"
                @searchedQuery="searchedQuery"
              ></card-header>
              <master-table
                :infoTable="queriedData"
                :columns="tableColumns"
                :showColumnStatus="false"
              >
                <template slot="addColumnsOperations">
                  <table-columns-operations
                    v-if="isShow()"
                    @handleView="handleView"
                    :showOperationEdit="false"
                    :canDelete="false"
                    :minWidth="120"
                  />
                </template>
              </master-table>
              <card-footer ref="cardfooter" :propPagination="pagination" />
            </div>
            <br />
          </card>
          <div v-if="details" class="col-12 text-center">
            <em
              class="nc-icon nc-stre-up"
              style="font-size: 25px; cursor: pointer"
              @click="handleViewDetails"
              v-tooltip.top-center="$t('common_words.hide_detail')"
            ></em>
          </div>
          <card v-if="details">
            <div class="row">
              <div class="col-12 mt-2">
                <p style="font-size: 17px" class="text-muted">
                  {{ $t('labor.worker_detail_info') }}
                </p>
              </div>
              <div class="col-12">
                <div class="table-responsive">
                  <table aria-describedby="table-details" class="table">
                    <tbody>
                      <tr class="shadow-sm">
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.farm') }}:</strong>
                          </h6>
                          {{ rowData.farm.name }}
                        </td>
                        <td>
                          <h6>
                            <strong
                              >{{ $t('common_words.code') }} -
                              {{ $t('labor.worker') }}:</strong
                            >
                          </h6>
                          {{ rowData.worker.code }} -
                          {{ rowData.worker.name }}
                        </td>
                        <td>
                          <h6>
                            <strong>{{ $t('common_words.save_date') }}:</strong>
                          </h6>
                          {{ rowData.header_date }}
                        </td>
                        <th>
                          <img
                            v-tooltip.top-center="
                              $t('common_words.geo_location_labor_detail')
                            "
                            style="width: 30px; height: 30px"
                            class="pointer"
                            src="/static/img/iconos/map.svg"
                            alt="Icono de Geolocalización"
                            @click="openMap"
                          />
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <el-dialog
                :title="$t('common_words.samples_map')"
                class="zoom-map el-dialog-img-zoom"
                top="15px"
                width="80%"
                :visible.sync="modals.map"
                :close="closeMap"
              >
                <multiple-map ref="map" :height="800" />
              </el-dialog>
            </div>
            <br />
            <div>
              <card-header
                :propPagination="paginationDetails"
                @searchedQuery="searchedQueryDetails"
              ></card-header>
              <master-table
                :infoTable="queriedDataDetails"
                :columns="tableColumnsDetails"
                :showColumnStatus="false"
              >
              </master-table>
              <card-footer
                :propPagination="paginationDetails"
                ref="cardfooterdetail"
              />
            </div>
          </card>
        </div>
        <div v-else>
          <card v-if="tableDataMobileTracks.length > 0">
            <br />
            <div>
              <card-header
                :propPagination="paginationMobileTracks"
                @searchedQuery="searchedQueryMobileTracks"
              ></card-header>
              <master-table
                :infoTable="queriedDataMobileTracks"
                :columns="tableColumnsMobileTracks"
                :showColumnStatus="false"
              >
                <template slot="addColumnsOperations">
                  <table-columns-operations
                    v-if="isShow()"
                    @handleView="handleViewMobileTrack"
                    :showOperationEdit="false"
                    :canDelete="false"
                    :minWidth="120"
                  />
                </template>
              </master-table>
              <card-footer
                :propPagination="paginationMobileTracks"
                ref="cardfootermobiletrack"
              />
            </div>
          </card>
          <div v-if="markingsMobileTracks" class="col-12 text-center">
            <em
              class="nc-icon nc-stre-up"
              style="font-size: 25px; cursor: pointer"
              @click="handleViewMarkings"
              v-tooltip.top-center="$t('common_words.hide_detail')"
            ></em>
            <card v-if="markingsMobileTracks">
              <div class="row">
                <div class="col-12 mt-2">
                  <p style="font-size: 17px" class="text-muted">
                    {{ $t('labor.worker_detail_info') }}
                  </p>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table aria-describedby="table-details" class="table">
                      <thead>
                        <tr class="shadow-sm">
                          <td>
                            <h6>
                              <strong>{{ $t('common_words.farm') }}:</strong>
                            </h6>
                            {{ rowDataMobileTrack.farm.name }}
                          </td>
                          <td v-if="markingsHaveLot()">
                            <h6>
                              <strong
                                >{{ $t('common_words.allotment') }}:</strong
                              >
                            </h6>
                            {{ rowDataMobileTrack.lot.name }}
                          </td>
                          <td>
                            <h6>
                              <strong>{{ $t('common_words.names') }}:</strong>
                            </h6>
                            {{ rowDataMobileTrack.user.name }}
                          </td>
                          <td>
                            <h6>
                              <strong
                                >{{ $t('common_words.save_date') }}:</strong
                              >
                            </h6>
                            {{ rowDataMobileTrack.header_date_save }}
                          </td>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </div>
                <el-dialog
                  :title="$t('common_words.samples_map')"
                  class="zoom-map el-dialog-img-zoom"
                  top="15px"
                  width="80%"
                  :visible.sync="modals.map"
                  :close="closeMap"
                >
                  <multiple-map ref="map" :height="800" />
                </el-dialog>
              </div>
              <div class="table-responsive">
                <table
                  class="table table-striped table-bordered not-last-td table-data"
                >
                  <thead>
                    <tr class="cusmtom-thead-color">
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                        style="width: 90px"
                      >
                        <strong>{{ $t('common_words.code') }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong>{{ $t('common_words.activity') }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong>{{
                          $t('common_words.number_of_records')
                        }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong>{{
                          $t('common_words.duration_in_hours')
                        }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong>{{
                          $t('common_words.duration_in_minutes')
                        }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong>{{ $t('common_words.average_speed') }}</strong>
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                      >
                        <strong
                          >{{
                            $t('common_words.distance_traveled')
                          }}
                          (Km)</strong
                        >
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                         style="width: 90px"
                      >
                        <strong>{{ $t('common_words.map') }}</strong>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(marking, index) in tableDataMobileMarkings"
                      :key="index"
                    >
                      <td class="text-center">
                        {{ marking.code }}
                      </td>
                      <td class="text-center">
                        {{ marking.name }}
                      </td>
                      <td class="text-center">
                        {{ marking.quantity }}
                      </td>
                      <td class="text-center">
                        {{ marking.duration_hours }}
                      </td>
                      <td class="text-center">
                        {{ marking.duration_minutes }}
                      </td>
                      <td class="text-center">
                        {{ marking.avg_speed_kmh }} Km/h
                      </td>
                      <td class="text-center">
                        {{ marking.distance_km }}
                      </td>
                      <td class="text-center">
                        <img
                          v-tooltip.top-center="
                            $t('common_words.geo_location_labor_detail')
                          "
                          style="width: 30px; height: 30px"
                          class="pointer"
                          src="/static/img/iconos/map.svg"
                          alt="Icono de Geolocalización"
                          @click="openMap"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </card>
          </div>
        </div>
      </div>

      <not-index-permissions v-else />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Pagination as LPagination } from 'src/components/index';
import { isset } from 'src/util/Util';
import configTable from 'src/views/Pages/Dashboard/Work/SmartTrack/report-table.js';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import MultipleMap from 'src/views/Pages/Dashboard/Work/SmartTrack/MultipleMap.vue';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    [MultipleMap.name]: MultipleMap,
    LPagination,
  },

  data() {
    return {
      activeName: 'filter',
      center: {
        lat: 10.8906,
        lng: -74.18756,
      },
      dataFilter: {
        farm: [],
        lot: [],
        activities: [],
        workers: [],
        users: [],
      },
      valueCollapse: null,
      activities: [],
      workers: [],
      users: [],
      details: false,
      detailsForm: {},
      fuseSearchDetails: null,
      model: null,
      paginationDetails: {},
      reportType: 0,
      searchQueryDetails: '',
      tableColumns: [],
      tableColumnsDetails: [],
      tableDataDetails: [],
      //tabla principal para la info del track movil
      device_type: 'mobile',
      tableDataMobileTracks: [],
      tableColumnsMobileTracks: [],
      searchQueryMobileTracks: [],
      paginationMobileTracks: {},
      fuseSearchMobileTracks: null,
      //Tabla que sera usada en un consolidado de N activity x tiempo
      markingsMobileTracks: false,
      tableDataMobileMarkings: [],
      tableColumnsMobileMarkings: [],
      searchQueryMobileMarkings: [],
      paginationMobileMarkings: {},
      fuseSearchMobileMarkings: null,
    };
  },

  computed: {
    ...configTable().SearchDetails,
    ...configTable().SearchMobileTracks,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    getDeviceType() {
      return [
        {
          id: 1,
          value: 'mobile',
          label: i18n.t('common_words.mobile'),
        },
        {
          id: 2,
          value: 'smartwatch',
          label: i18n.t('common_words.smartwatch'),
        },
      ];
    },
    getPermision() {
      return this.isSuper() ? false : true;
    },
  },

  mixins: [MixinMasters, MixinMenu, MixinPermissions, MixinArcgisMap],

  watch: {
    '$i18n.locale': ['setupTable', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.workers = this.concatAll(this.workers.splice(1));
      this.activities = this.concatAll(this.activities.splice(1));
      this.users = this.concatAll(this.users.splice(1));
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    handleFilter(data) {
      this.dataFilter = { ...this.dataFilter, ...data };
      this.details = false;
      this.markingsMobileTracks = false;
      if (this.device_type == 'mobile') {
        this.getDataReportActivityByTrackMobile();
      } else {
        this.getDataSamples();
      }
    },

    handleChangeDeviceType() {
      if (isset(this.device_type)) {
        if (this.device_type == 'mobile') {
          this.dataFilter.workers = [];
          this.details = false;
        } else this.dataFilter.users = [];
      } else {
        this.$set(this, 'device_type', 'mobile');
        this.dataFilter.workers = [];
        this.markingsMobileTracks = false;
      }
    },

    getDataSamples() {
      this.showHideLoading(true);
      const route = 'agrotrack/report';
      const data = {
        ...this.dataFilter,
        route: route,
      };
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.fuseSearch = new Fuse(this.tableData, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumns.map((prop) => {
                return prop.prop;
              }),
            });
            this.pagination.perPage = 5;
            this.pagination.currentPage = 1;
            this.searchQuery = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    handleView(_, row) {
      this.showHideLoading(true);
      this.details = false;
      this.rowData = row;
      const data = 'agrotrack/reportdetails/' + this.rowData.id;
      Axios.getMasters(data)
        .then((response) => {
          this.tableDataDetails = response.data.data;
          this.fuseSearchDetails = new Fuse(this.tableDataDetails, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumnsDetails.map((prop) => {
              return prop.prop;
            }),
          });
          this.details = true;
          this.paginationDetails.perPage = 5;
          this.paginationDetails.currentPage = 1;

          this.showHideLoading();

          setTimeout(() => {
            window.scrollTo({
              top: document.getElementsByClassName('footer')[0].offsetTop - 500,
              behavior: 'smooth',
            });
          }, 100);
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowData.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },

    searchedQueryDetails(searchedValue) {
      this.searchQueryDetails = searchedValue;
    },

    handleViewMobileTrack(_, row) {
      this.showHideLoading(true);
      this.markingsMobileTracks = false;
      this.rowDataMobileTrack = row;
      const data = 'mobiletrack/report/' + this.rowDataMobileTrack.id;
      Axios.getMasters(data)
        .then((response) => {
          this.tableDataMobileMarkings = response.data.data;
          this.markingsMobileTracks = true;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.rowDataMobileTrack.show = true;
          SweetAlert.warning(error.response.data.message);
        });
    },
    markingsHaveLot() {
      return isset(this.rowDataMobileTrack.lot.name) ? true : false;
    },

    openMap() {
      this.modals.map = true;
      this.showHideLoading(true);

      // Esperamos un ciclo de render para que aparezca el <multiple-map>
      this.$nextTick(() => {
        const mapEl = this.$refs.map.$refs.multipleMap;
        if (this.device_type != 'mobile') {
          this.loadSmartTrackMap(this.tableDataDetails, mapEl);
        } else {
          this.loadSmartTrackMap(
            this.tableDataMobileMarkings,
            mapEl,
            null,
            null,
            {
              pointsField: 'geo_data',
              lineField: 'geo_data_line',
              sortByHour: true, // recomendado
              deviceType: 'mobile',
            }
          );
        }

        try {
          document.getElementById('toolbarDiv').style = 'top: 16%;right: 18px;';
        } catch (e) {}
        this.showHideLoading(false);
      });
    },

    closeMap() {
      this.modals.map = false;
    },

    handleViewDetails() {
      this.details = !this.details;
      this.tableData.forEach((element) => {
        element.show = true;
      });
    },

    handleViewMarkings() {
      this.markingsMobileTracks = !this.markingsMobileTracks;
      this.tableDataMobileMarkings.forEach((element) => {
        element.show = true;
      });
    },

    setupTable() {
      const { Table, TableDetails, TableDataMobileTracks } = configTable();
      this.pagination = { ...Table.pagination };
      this.tableColumns = Table.tableColumns;

      this.paginationDetails = { ...TableDetails.pagination };
      this.tableColumnsDetails = TableDetails.tableColumns;

      this.paginationMobileTracks = { ...TableDataMobileTracks.pagination };
      this.tableColumnsMobileTracks = TableDataMobileTracks.tableColumns;
    },

    getDataReportActivityByTrackMobile() {
      this.showHideLoading(true);
      const route = 'mobiletrack/report';
      const data = {
        ...this.dataFilter,
        route: route,
      };

      Axios.postMasters(data)
        .then((response) => {
          this.tableDataMobileTracks = response.data.data;
          if (this.tableDataMobileTracks.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.fuseSearchMobileTracks = new Fuse(this.tableDataMobileTracks, {
              useExtendedSearch: true,
              threshold: 0.3,
              keys: this.tableColumnsMobileTracks.map((prop) => {
                return prop.prop;
              }),
            });
            this.paginationMobileTracks.perPage = 5;
            this.paginationMobileTracks.currentPage = 1;
            this.searchQueryMobileTracks = '';
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    searchedQueryMobileTracks(searchedValue) {
      this.searchQueryMobileTracks = searchedValue;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
      Axios.getMasters('works/workers/indexField').then((response_workers) => {
        this.workers = this.concatAll(response_workers.data.data);
        this.showHideLoading();
      });

      Axios.getMasters('works/activities/only/field').then(
        (response_activities) => {
          this.activities = this.concatAll(response_activities.data.data);
          this.showHideLoading();
        }
      );

      Axios.getMasters('users/indexfield').then((response_users) => {
        this.users = this.concatAll(response_users.data.data);
        this.showHideLoading();
      });
    } else {
      this.showMessageAccess();
    }
  },
  mounted() {
    this.selectedItemOnMenu('works/laborheader');
  },
  destroyed() {
    this.deselectedItemOnMenu('works/laborheader');
  },
};
</script>
